async function fetchData(
  url,
  method = "GET",
  customOptions = {},
  isJSON = true
) {
  const defaultOptions = {
    method,
    headers: {
      "Content-Type": "application/json",
      Accept: isJSON ? "application/json" : "text/html",
    },
  };

  const options = { ...defaultOptions, ...customOptions };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return isJSON ? await response.json() : await response.text();
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

window.fetchData = fetchData;
